import ReservationContext from 'context/ReservationContext';
import {GroupFilterContext} from 'context/groupFilterContext';
import {useTranslation} from 'hooks/translations/useCustomTranslation';
import {useBackgroundStyleConfigs} from 'hooks/useBackgroundStyleConfigs';
import {TGroupPriceConfig} from 'hooks/usePricesRequestState';
import isEqual from 'lodash/isEqual';
import Image from 'next/image';
import {useRouter} from 'next/router';
import React, {useContext, useState} from 'react';

// import {useCallback} from 'react';
import {Group} from 'lib/api/backend.schemas';

import formatPrice from 'utils/formateHelpers/formatPrice';

import {palette} from 'styles/mui/scss';

import {Box, Progress, Typography} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';
import {
  GroupIcons,
  InfoDivider,
  VehicleFlags,
  VehicleLimitations,
} from 'components/section-components/reservation/Group';
import PreferredVehicle from 'components/section-components/reservation/step1/ResultCard/PreferredVehicle';

import styles from './ResultCard.module.scss';

const ResultCardMobile = ({
  group,
  groupPriceConfig = {} as TGroupPriceConfig,
  isVisible = true,
  sort = 0,
  clickHandler,
}: {
  group: Group;
  groupPriceConfig?: TGroupPriceConfig;
  isVisible?: boolean;
  sort?: number;
  clickHandler?: (group, selectedVehicle) => void;
}) => {
  const [selectedVehicle, setSelectedVehicle] = useState<string>();
  const {loading, price} = groupPriceConfig;
  const {withPrice, currentCategory} = useContext(GroupFilterContext);
  const {oneWay} = useContext(ReservationContext);
  const {locale} = useRouter();

  const {resultCardMobileBackgroundColor} = useBackgroundStyleConfigs();

  const {t} = useTranslation(['reservation', 'common', 'groupType']);
  return (
    <button
      onClick={() => clickHandler(group, selectedVehicle)}
      className={styles.resultCardMobile}
      style={{
        display: !isVisible ? 'none' : 'flex',
        backgroundColor:
          // vehicleInformation?.recommandation ? '#fffcd9' :
          resultCardMobileBackgroundColor,
        order: sort,
      }}
      data-testid="carGroup"
      data-car-group={group.id}
    >
      <VehicleFlags
        sx={{position: 'absolute', top: '15px', left: '15px'}}
        group={group}
        oneWay={oneWay}
      />
      <Box
        className={styles.groupImageBox}
        sx={{position: 'relative', margin: '0 auto', width: '75%'}}
      >
        <Image
          src={group?.image?.small}
          alt=""
          width={500}
          height={500}
          className={styles.imageMobile}
        />
      </Box>
      <Box>
        <Box className={styles.carInformation}>
          <Typography className={styles.group}>
            {t('group')} {group?.id}
          </Typography>
          <InfoDivider />
          <Typography className={styles.type}>
            {t(group?.type || 'notDefined', {ns: 'groupType'})}
          </Typography>
        </Box>
        <Typography className={styles.exampleCar}>
          {t('example', {ns: 'common'})} {group?.description}
        </Typography>
        <VehicleLimitations group={group} />
        {group?.vehicles ? (
          <Box className={styles.preferredVehicleBoxMobile}>
            <PreferredVehicle
              vehicle={selectedVehicle}
              group={group}
              setSelectedVehicle={setSelectedVehicle}
            />
          </Box>
        ) : null}
        {oneWay && group?.lowAvailability && (
          <Box className={styles.lowAvailabilityBox}>
            <CustomIcon name="info" className={styles.lowAvailabilityInfoIcon} />
            <Typography component="span">{t('lowAvailabilityHint')}</Typography>
          </Box>
        )}
      </Box>
      <Box className={styles.mobileIconPriceWrapper}>
        {(group?.drivingExperience && group?.numberDoors) ||
        (group?.cargoLoad && group?.licenseClass) ? (
          <Box sx={{marginTop: '15px'}}>
            <GroupIcons group={group} />
          </Box>
        ) : null}
        {withPrice ? (
          loading || !price ? (
            <Progress width="20" strokeColor={palette.colorBlack} />
          ) : (
            <Typography className={styles.price}>{formatPrice(price, locale)} €</Typography>
          )
        ) : null}
      </Box>
    </button>
  );
};

export default React.memo(ResultCardMobile, isEqual);
